


























































import Vue from 'vue';
import {
  CampaignInterface,
  CampaignStatistic,
  PaginationData,
  ResponseExport,
  typeTraffic,
  userRoles,
} from '@/types';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import Table from '@/components/table/Table.vue';
import {
  Column,
  ColumnItems,
  ColumnType,
  FilterTypeField,
  Row,
} from '@/components/table/types';
// @ts-ignore
import { saveAs } from 'file-saver';
import FieldDatePicker from '@/components/form/FieldDatePicker.vue';
import filterParams from '@/components/table/utils/filterParameters';
import { mapGetters } from 'vuex';
import { sortDetailStatisticsChartData } from '@/components/table/utils/sortDetailStatisticsData';

export default Vue.extend({
  name: 'CampaignStatistics',
  components: {
    Table,
    FieldDatePicker,
  },
  async mounted() {
    const params = filterParams.getUrlFilter(this.$route.query['filter']) || {};
    this.$store.commit(
      'changeTitle',
      this.$t('pages.statisticsCampaign.title')
    );
    if (params['from_date'] && params['to_date']) {
      this.datePeriod = [params['from_date'], params['to_date']];
    }

    await this.getCampaignStatistics(params);

    await this.$store.dispatch('countries');
    const country = this.columns.find((item: Column) => {
      return item.field === 'geo';
    });
    if (country) {
      country.items = this.$store.getters.countriesList;
    }

    await this.$store.dispatch('ssps');
    const ssps = this.columns.find((item: Column): boolean => {
      return item.field === 'ssp_id';
    });
    if (ssps) {
      ssps.items = this.sspList;
    }

    if (this.userCan(this.roles.ADMIN)) {
      await this.$store.dispatch('users');
      const users = this.columns.find((item: Column): boolean => {
        return item.field === 'user_id';
      });

      if (users) {
        users.items = this.userList;
      }
    }
  },
  computed: {
    statistics(): Array<any> {
      return this.$store.state.statistics.campaign.data.map(
        (item: CampaignStatistic) => item
      );
    },
    total(): Row {
      return this.$store.state.statistics.campaign.total;
    },
    paginationData(): PaginationData {
      return this.$store.state.statistics.campaign.paginationData;
    },
    ...mapGetters({
      userCan: 'userCan',
      sspList: 'sspList',
      userList: 'userList',
    }),
  },
  methods: {
    defaultPeriod() {
      const from = new Date();
      const to = new Date();
      this.changePeriod([
        ('0' + to.getDate()).slice(-2) +
          '.' +
          ('0' + (to.getMonth() + 1)).slice(-2) +
          '.' +
          to.getFullYear(),
        ('0' + from.getDate()).slice(-2) +
          '.' +
          ('0' + (from.getMonth() + 1)).slice(-2) +
          '.' +
          from.getFullYear(),
      ]);
    },
    changePeriod(period) {
      this.datePeriod = period;
    },
    async getCampaignStatistics(searchData, expandRow = []) {
      expandRow.splice(0);
      let columns: Array<string> = [];
      this.loadData = true;
      this.searchData = searchData;
      this.columns.map((item: Column, index) => {
        if (searchData[item.field]) {
          this.columns[index].filterValue = searchData[item.field];
        } else {
          this.columns[index].filterValue = null;
        }
      });
      if (
        !this.datePeriod.length ||
        this.datePeriod.find((i) => i === null) === null
      ) {
        this.defaultPeriod();
      }
      if (Array.isArray(this.datePeriod) && this.datePeriod.length == 2) {
        this.searchData['from_date'] = this.datePeriod[0];
        this.searchData['to_date'] = this.datePeriod[1];
      }

      if (this.searchData['sort']) {
        this.sort = this.searchData['sort'];
      }
      columns = this.columns
        .filter((col) => {
          return !!col.visible || col.visible == undefined;
        })
        .map((col) => col.field);

      await this.$store.dispatch('campaignStatistics', {
        searchData: this.searchData,
        columns,
      });
      filterParams.toUrl({
        ...this.searchData,
      });
      filterParams.saveFilter();
      this.loadData = false;
    },
    exportData() {
      this.$confirm({
        title: this.$t('body.popup.export.title'),
        content: this.$t('body.popup.export.message'),
        cancelText: this.$t('body.popup.buttons.no'),
        okText: this.$t('body.popup.buttons.yes'),
      })
        .then(() => {
          this.exportDataConfirmed();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async exportDataConfirmed() {
      const response: ResponseExport = await this.$store.dispatch(
        'exportCampaignStatistics',
        this.searchData
      );
      saveAs(response.download_link, 'export.xls');
    },
    editCampaign(campaign: CampaignInterface) {
      this.$router.push('/campaign/update/' + campaign.id);
    },
    cloneCampaign(campaign: CampaignInterface) {
      this.$router.push('/campaign/clone/' + campaign.id);
    },
    deleteCampaign(campaign: CampaignInterface) {
      this.$confirm({
        title: this.$t('pages.campaigns.popup.title'),
        content: this.$t('pages.campaigns.popup.message'),
        cancelText: this.$t('body.popup.buttons.no'),
        okText: this.$t('body.popup.buttons.yes'),
      }).then(() => {
        if (!campaign.id) {
          return;
        }
        this.deleteConfirmed(campaign.id);
      });
    },
    async deleteConfirmed(id: number) {
      await this.$store.dispatch('deleteCampaign', { id });
    },
    changeStatusCampaign(index: number) {
      const campaign = this.statistics[index];
      const campaignStatus = campaign.status;

      if (campaignStatus['value'] === 'active') {
        campaignStatus['label'] = this.$t('body.table.body.status.notActive');
        campaignStatus['value'] = 'draft';
      } else {
        campaignStatus['label'] = this.$t('body.table.body.status.active');
        campaignStatus['value'] = 'active';
      }

      const formData = new FormData();

      formData.append('status', campaignStatus.value);

      this.$store
        .dispatch('changeStatusCampaign', {
          id: campaign.id,
          formData,
        })
        .then((response) => {
          if (response.success) {
            campaign.status = campaignStatus;
          }
        });
    },
    async formatDetailStatistics(data, expandData) {
      try {
        const newData = {
          id: expandData.index,
          detailPeriod: expandData.expandPeriod,
          ...data,
        };

        const detailDataItem: any = await sortDetailStatisticsChartData(
          newData,
          this.columns
        );

        if (!detailDataItem.series.length) {
          detailDataItem.campaignId = expandData.index;
          detailDataItem.detailPeriod = expandData.expandPeriod;
        }

        Vue.set(this.detailStatisticsData, `${detailDataItem.campaignId}`, {
          row: {
            ...detailDataItem,
          },
        });
      } catch (err) {
        console.warn(err);
      }
    },
    async getDetailStatistics(data) {
      const columns = this.columns
        .filter((c) => c.detailStatistics)
        .map((c) => c.field);

      this.expandLoadData = true;
      const response = await this.$store.dispatch('detailCampaignStatistics', {
        periods: {
          id: data?.index,
          from_date: this.datePeriod[0],
          to_date: this.datePeriod[1],
          detail_period: data?.expandPeriod,
        },
        columns,
      });

      if (response?.success) {
        await this.formatDetailStatistics(response.data.data, data);
      } else {
        await this.formatDetailStatistics(null, data);
      }
      this.expandLoadData = false;
    },
    changeExpand(data) {
      const hasAlready = Object.values(this.detailStatisticsData).some(
        (value: any) => {
          return (
            value.row.campaignId == data.index &&
            value.row.detailPeriod === data.expandPeriod
          );
        }
      );

      if (hasAlready) return;

      this.getDetailStatistics({
        index: data.index,
        expandPeriod: data.expandPeriod,
      });
    },
  },
  data() {
    return {
      searchData: {},
      datePeriod: [] as Array<string>,
      detailStatisticsData: {},
      columns: [
        {
          name: this.$t('pages.statisticsCampaign.table.header.id'),
          field: 'id',
          filterValue: null,
          isSticky: true,
          multiple: true,
          options: {
            minWidth: '135px',
            left: '0',
          },
          filterTypeField: FilterTypeField.FILTER_TYPE_INPUT,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.campaign'),
          field: 'name',
          useInFilter: false,
          isSticky: true,
          options: {
            left: '135px',
          },
          filterValue: null,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.geo'),
          field: 'geo',
          items: [],
          filterTypeField: FilterTypeField.FILTER_TYPE_DROPDOWN,
          filterValue: null,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.trafficType'),
          field: 'type_traffic',
          items: [
            {
              label: this.$t('body.table.body.trafficType.banner'),
              htmlLabel: `<span class="td-status">${this.$t(
                'body.table.body.trafficType.banner'
              )}</span>`,
              value: typeTraffic.BANNER,
            },
            {
              label: this.$t('body.table.body.trafficType.push'),
              htmlLabel: `<span class="td-status">${this.$t(
                'body.table.body.trafficType.push'
              )}</span>`,
              value: typeTraffic.PUSH,
            },
            {
              label: this.$t('body.table.body.trafficType.native'),
              htmlLabel: `<span class="td-status">${this.$t(
                'body.table.body.trafficType.native'
              )}</span>`,
              value: typeTraffic.NATIVE,
            },
          ] as Array<ColumnItems>,
          filterValue: null,
          filterTypeField: FilterTypeField.FILTER_TYPE_DROPDOWN,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.quantitySite'),
          field: 'count_sites',
          filterValue: null,
          useInFilter: false,
          visible: false,
          type: ColumnType.TYPE_LINK,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.views'),
          field: 'count_view',
          filterValue: null,
          useInFilter: false,
          detailStatistics: true,
          type: ColumnType.TYPE_NUMBER,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.clicks'),
          field: 'count_click',
          filterValue: null,
          useInFilter: false,
          detailStatistics: true,
          type: ColumnType.TYPE_NUMBER,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.orders'),
          field: 'count_lead',
          filterValue: null,
          useInFilter: false,
          visible: false,
          detailStatistics: true,
          type: ColumnType.TYPE_NUMBER,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.leads'),
          field: 'confirmed',
          filterValue: null,
          useInFilter: false,
          detailStatistics: true,
          type: ColumnType.TYPE_NUMBER,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.expenditure'),
          field: 'sum_revenue',
          filterValue: null,
          useInFilter: false,
          type: ColumnType.TYPE_NUMBER,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.ctr'),
          field: 'ctr',
          filterValue: null,
          useInFilter: false,
          detailStatistics: true,
          type: ColumnType.TYPE_NUMBER,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.cpc'),
          field: 'cpc',
          filterValue: null,
          useInFilter: false,
          detailStatistics: true,
          type: ColumnType.TYPE_NUMBER,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.cpa'),
          field: 'cpa',
          filterValue: null,
          useInFilter: false,
          detailStatistics: true,
          type: ColumnType.TYPE_NUMBER,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.cpl'),
          field: 'cpl',
          filterValue: null,
          useInFilter: false,
          detailStatistics: true,
          type: ColumnType.TYPE_NUMBER,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.revenue'),
          field: 'order_cost',
          filterValue: null,
          useInFilter: false,
          visible: false,
          detailStatistics: true,
          type: ColumnType.TYPE_NUMBER,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.roi'),
          field: 'roi',
          filterValue: null,
          useInFilter: false,
          visible: false,
          detailStatistics: true,
          type: ColumnType.TYPE_NUMBER,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.status'),
          field: 'status',
          items: [
            {
              label: this.$t('body.table.body.status.active'),
              htmlLabel: `<span class="td-status td-status-active">${this.$t(
                'body.table.body.status.active'
              )}</span>`,
              value: 'active',
            },
            {
              label: this.$t('body.table.body.status.notActive'),
              htmlLabel: `<span class="td-status td-status-no-active">${this.$t(
                'body.table.body.status.notActive'
              )}</span>`,
              value: 'draft',
            },
          ] as Array<ColumnItems>,
          filterValue: null,
          filterTypeField: FilterTypeField.FILTER_TYPE_DROPDOWN,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.avgCr'),
          field: 'avgCR',
          filterValue: null,
          useInFilter: false,
          visible: false,
          detailStatistics: true,
          type: ColumnType.TYPE_NUMBER,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.avgPrice'),
          field: 'avg_revenue',
          filterValue: null,
          useInFilter: false,
          visible: false,
          detailStatistics: true,
          type: ColumnType.TYPE_NUMBER,
        },
        {
          name: this.$t('pages.statisticsCampaign.table.header.avgFloor'),
          field: 'avg_bidfloor',
          filterValue: null,
          useInFilter: false,
          visible: false,
          detailStatistics: true,
          type: ColumnType.TYPE_NUMBER,
        },
        {
          name: this.$t('pages.statisticsCampaign.topBar.selectSsp'),
          field: 'ssp_id',
          items: [],
          visible: false,
          filterTypeField: FilterTypeField.FILTER_TYPE_DROPDOWN_FIELD,
          filterValue: null,
        },
        {
          name: this.$t('pages.statisticsCampaign.topBar.selectUser'),
          field: 'user_id',
          items: [],
          visible: false,
          filterTypeField: FilterTypeField.FILTER_TYPE_DROPDOWN_FIELD,
          filterValue: null,
          role: userRoles.ADMIN,
        },
      ] as Array<Column>,
      loadData: true,
      expandLoadData: false,
      sort: null as string | null,
      gridOptions: {
        pagination: true,
      },
      roles: {
        ADMIN: userRoles.ADMIN,
        MANAGER: userRoles.MANAGER,
        SSP: userRoles.SSP,
        PUBLISHER: userRoles.PUBLISHER,
      },
    };
  },
});
